import React from 'react';

// MUI Theme
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { SettingsState } from '../../../../redux/slices/settingsSlice';
import FormInputCollection from '../../../common/FormInputCollection/FormInputCollection';

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: '5px',
  },
  toggleButtonGroup: {
    height: '36px',
    marginLeft: '4px',
    backgroundColor: 'white',
  },
  toggleButton: {
    '&.MuiToggleButton-root': {
      fontSize: 'x-small',
      whiteSpace: 'nowrap',
    },
  },
}));

interface TasksQueueSeverityTabsProps {
  taskSeverityToggles: number[];
  settingStates: SettingsState;
  handleTaskSeverityToggle: (event: React.MouseEvent<HTMLElement>, newValues: number[]) => void;
}

const TasksQueueSeverityTabs: React.FC<TasksQueueSeverityTabsProps> = React.memo(
  ({ taskSeverityToggles, settingStates, handleTaskSeverityToggle }) => {
    const classes = useStyles();

    return (
      <div className={classes.container}>
        <FormInputCollection label='Severity' style={{ marginLeft: '24px' }}>
          <ToggleButtonGroup
            value={taskSeverityToggles}
            onChange={handleTaskSeverityToggle}
            aria-label='Task Severity'
            className={classes.toggleButtonGroup}
          >
            {settingStates.taskSeverity?.value.map((task) => {
              return (
                <ToggleButton key={task.text} value={task.text} aria-label={task.value} className={classes.toggleButton}>
                  {task.value}
                </ToggleButton>
              );
            })}
          </ToggleButtonGroup>
        </FormInputCollection>
      </div>
    );
  },
);

export default TasksQueueSeverityTabs;
